__turbopack_context__.v({
  "container": "OpenDistributionButton-module-scss-module__K8Q1ia__container",
  "inverted": "OpenDistributionButton-module-scss-module__K8Q1ia__inverted",
  "outputInfo": "OpenDistributionButton-module-scss-module__K8Q1ia__outputInfo",
});
